import React, { useState } from "react";
import "./ContactForm.css";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";

const ContactForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    company: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // submit logic here
  };

  return (
    <section className="oglitz-contact-form">
      <div className="oglitz-contact-container">
        {/* LEFT – TRUST & CONTEXT */}
        <div className="oglitz-contact-info">
          <span className="oglitz-form-badge">Contact Our Team</span>

          <h2>
            Tell Us About <span>Your Project</span>
          </h2>

          <p>
            Share your requirements with our experts. We typically respond
            within <strong>24 business hours</strong>.
          </p>

          <ul className="oglitz-form-points">
            <li>✔ Dedicated solution architects</li>
            <li>✔ NDA & data confidentiality</li>
            <li>✔ India & Dubai delivery teams</li>
            <li>✔ No obligation consultation</li>
          </ul>

          <div className="oglitz-contact-trust">
            <div>
              <WhatsAppIcon />
              <span>WhatsApp preferred for quick response</span>
            </div>
            <div>
              <LockIcon />
              <span>Your data is 100% secure</span>
            </div>
          </div>
        </div>

        {/* RIGHT – FORM */}
        <div className="oglitz-contact-card">
          <form onSubmit={handleSubmit}>
            <div className="oglitz-form-row">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={form.name}
                onChange={handleChange}
                required
              />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="oglitz-form-row">
              <input
                type="text"
                name="company"
                placeholder="Company / Organization"
                value={form.company}
                onChange={handleChange}
              />
              <input
                type="tel"
                name="phone"
                placeholder="Phone / WhatsApp"
                value={form.phone}
                onChange={handleChange}
                required
              />
            </div>

            <textarea
              name="message"
              placeholder="Briefly describe your project or requirement"
              value={form.message}
              onChange={handleChange}
              required
            />

            <button type="submit" className="oglitz-submit-btn">
              Start the Conversation
            </button>

            <p className="oglitz-form-note">
              <EmailIcon /> We’ll never share your information.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
